import { priceTrackingEventContext } from '../course-price-events/course-card-price-events';
import { coursePriceToText } from '../price-text/course-price-to-text';
/**
 * Merges pricing properties from the `Course` object with tracking event context to
 * produce props for a price text component.
 *
 * @see {@link `@udemy/browse-course#StaticPriceText`} and
 * {@link `@udemy/browse-course#DynamicPriceText`}.
 */
export const priceTextPropsWithTracking = ({
  course,
  priceTextProps
}) => ({
  ...coursePriceToText({
    discount: course.discount,
    price_detail: course.price_detail
  }),
  ...priceTrackingEventContext({
    course
  }),
  ...priceTextProps
});
//# sourceMappingURL=course-card-price.js.map